import { Pipe, PipeTransform } from '@angular/core'
import { LocalEPGProgram } from '../interfaces/local-epg'
import moment from 'moment'
import { TranslateService } from '@ngx-translate/core'

@Pipe({
  name: 'programDescription',
  standalone: true,
})
export class ProgramDescriptionPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(program: LocalEPGProgram | null | undefined, locale?: string): string {
    if (!program) {
      return ''
    }

    const currentLocale = locale || moment.locale()

    const currentTranslation = program.translations[currentLocale]
    if (currentTranslation?.description) {
      return currentTranslation.description
    }

    const defaultTranslation = program.translations[program.defaultTranslationCode]
    if (defaultTranslation?.description) {
      return defaultTranslation.description
    }

    const availableTranslations = Object.keys(program.translations)
    for (const langCode of availableTranslations) {
      const translation = program.translations[langCode]
      if (translation?.description) {
        return translation.description
      }
    }

    return this.translateService.instant('PAGES.IPG.NO_PROGRAM_INFO_SHORT')
  }
}
